import React, { useState, useRef, useEffect } from "react";
import logo from "../../Assets/Images/h-rooms-01.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import WOW from 'wowjs';
import 'animate.css';
import twitter from '../../Assets/Images/twitterx.svg'
import {
  faFacebook,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faSquareWhatsapp,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import {
  faInfoCircle,
  faEyeSlash,
  faEye,
  faUsers,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faBank,
} from "@fortawesome/free-solid-svg-icons";
import Plus from "@rsuite/icons/legacy/Plus";
// import { toast, ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import { ApiEndPoint, ApiToken } from "../../Data/Api";
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader";
import { Tooltip, Whisper } from "rsuite";
import PasswordStrengthBar from "react-password-strength-bar";
import { SelectPicker } from "rsuite";
import { countryListLocal } from "../../Data/CountryList";
import { faCreditCard, faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { Uploader, Button, InputPicker } from "rsuite";
import { Country, City } from "country-state-city";
import OtpInput from "react-otp-input";
import moment from "moment/moment";
function Register() {
   useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  const baseurl = ApiEndPoint();
  const token = ApiToken();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isClearable, setIsClearable] = useState(true);
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [initialCity, setInitialCity] = useState([]);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [activeStep, setActiveStep] = useState(1); // Active step state
  const [paymentDocument, setPaymentDocument] = useState([]);
  const [fileIdProf, setFileIdProf] = useState(null);
  const [filesUploadDocument, setFilesUploadDocument] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [otp, setOtp] = useState("");
  const currentUpload = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [personalInfoErrors, setPersonalInfoErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [timer, setTimer] = useState(60);
  const [isExpired, setIsExpired] = useState(false);

  const [checkingAuth, setCheckingAuth] = useState(true); // Block UI render until check is done
  useEffect(() => {
    let countdown;

    if (timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsExpired(true);
    }

    return () => clearInterval(countdown);
  }, [timer]);

  const [requirementsStatus, setRequirementsStatus] = useState({
    length: false,
    lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
  });
  const [formData, setFormData] = useState({
    personalInfo: {
      email: "",
      name: "",
      // firstName: "",
      // lastName: "",
      password: "",
      confirmPassword: "",
      role: "",
    },
    companyInfo: {
      companyName: "",
      address: "",
      contactNo: "",
      // phnono: "",
      website: "",
      country: "",
      city: "",
      countryObj: null,
      zipcode: "",
    },
    billingInfo: {
      accountName: "",
      accountNumber: "",
      IBAN: "",
      accountCredit: "",
    },
  });

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const loginTime = localStorage.getItem("loginTime");
    const currentTime = new Date().getTime();

    if (token && loginTime && currentTime - loginTime < 7200000) {
      navigate("/", { replace: true });
    } else {
      setCheckingAuth(false); // Only show UI if not redirecting
    }
  }, []);

  useEffect(() => {
    // const countryOptions = countryListLocal.item.map((country) => ({
    //   value: country.cca2,
    //   label: country.name.common,
    //   flag: country.flags.png,
    //   phoneCode: country.idd.root + country.idd.suffixes[0],
    // }));
    const countryOptions = countryListLocal.item
      .filter(
        (country) =>
          country.name.common !== "Mayotte" &&
          country.name.common !== "United States Virgin Islands" &&
          country.name.common !== "Niue"
      ) // Exclude specified countries
      .map((country) => ({
        value: country.name.common,
        label: country.name.common,
        flag: country.flags.png,
        code: country.cca2,
        phoneCode:
          country.cca2 === "US"
            ? country.idd.root
            : country.idd.root + (country.idd.suffixes[0] || ""), // Handle case where suffixes may not exist
      }));
    setCountryList(countryOptions);
  }, []);

  if (checkingAuth) {
    return null; // Or return a spinner if you like
  }
  const handleChange = (e, section) => {
    const { name, value } = e.target;

    // Password requirement checks (if needed)
    if (section === "personalInfo" && name === "password") {
      setRequirementsStatus({
        length: value.length >= 8,
        lowercase: /[a-z]/.test(value),
        uppercase: /[A-Z]/.test(value),
        number: /\d/.test(value),
        specialChar: /[#.\-?!@$%^&*]/.test(value),
      });
    }

    if (name === "companyName") {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Company Name.",
        }));
      } else if (trimmedValue.length < 10 || trimmedValue.length > 50) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Company Name must be between 10 to 50 characters.",
        }));
      } else {
        // Valid input, remove error
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "address") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Street no",
        }));
      } else {
        // Remove the error if input is valid
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "contactNo") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Contact Number.",
        }));
      } else if (!/^\+?\d{8,14}$/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Contact Number must be between 8 and 15 digits.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }
    if (name === "zipcode") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Postal code.",
        }));
      } else if (!/^[A-Za-z0-9\s\-]{3,12}$/.test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]:
            "Postal Code must be 3–12 characters and can include letters, numbers, spaces, or hyphens.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "name") {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Please enter your Full Name.",
        }));
      } else if (trimmedValue.length < 2) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Name must be at least 2 characters.",
        }));
      } else if (trimmedValue.length > 40) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Full name cannot be longer than 40 characters.",
        }));
      } else if (!/^[a-zA-Z\s\-]+$/.test(trimmedValue)) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Full Name cannot contain numbers or special characters.",
        }));
      } else {
        setPersonalInfoErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "role") {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Please enter your position.",
        }));
      } else if (trimmedValue.length < 2) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Position must be at least 2 characters.",
        }));
      } else {
        setPersonalInfoErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "email") {
      if (!value.trim()) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Email",
        }));
      } else if (!ValidEmail(value)) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Please enter a valid email address.",
        }));
      } else {
        setPersonalInfoErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "confirmPassword") {
      const confirmPasswordd = value.trim();
      const password = formData.personalInfo.password?.trim() || "";

      if (!confirmPasswordd) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Please Enter Confirm Password.",
        }));
      } else if (confirmPasswordd !== password) {
        setPersonalInfoErrors((prev) => ({
          ...prev,
          [name]: "Password and Confirm Password do not match.",
        }));
      } else {
        setPersonalInfoErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    // Update the actual form data
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  };

  const handleselectCountry = (value) => {
    if (value !== null) {
      const allcity = City.getCitiesOfCountry(value.code);

      const uniqueCities = allcity.filter(
        (city, index, self) =>
          index === self.findIndex((c) => c.name === city.name)
      );

      const cityOptions = uniqueCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));

      setInitialCity(cityOptions.slice(0, 130));
      setCityList(cityOptions);
    } else {
      setInitialCity([]);
      setCityList([]);
    }

    const cont = countryList.find((item) => item.code === value?.code);

    setFormData((prev) => ({
      ...prev,
      companyInfo: {
        ...prev.companyInfo,
        country: cont?.label || "",
        city: "",
        phnono: cont?.phoneCode || "",
        countryObj: value,
        contactNo: cont?.phoneCode || "",
      },
    }));

    // ✅ Validation
    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!value) {
        newErrors.country = "Please Select Country.";
      } else {
        delete newErrors.country;
      }
      return newErrors;
    });
  };

  const GetCities = async (country) => {
    var data = {
      country_Code: country,
    };
    try {
      const response = await axios.post(
        baseurl + "/api/get_Cities_Using_Code",
        data
      );
      const cityOptions = response.data.country.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setInitialCity(cityOptions.slice(0, 130));
      setCityList(cityOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const handleselectCity = (value) => {
    setFormData((prev) => ({
      ...prev,
      companyInfo: {
        ...prev.companyInfo,
        city: value,
      },
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };
      if (!value) {
        newErrors.city = "Please Select City.";
      } else {
        delete newErrors.city;
      }
      return newErrors;
    });
  };

  const handleNext = () => {
    if (activeStep === 1) {
      if (handlecompanyinfo()) {
        return;
      } else {
        setActiveStep(activeStep + 1);
      }
    } else if (activeStep === 2) {
      setActiveStep(activeStep + 1);
    }
  };
  const handleFileChange = (fileList) => {
    const bytesInMB = 1048576;
    const validFiles = [];

    fileList.forEach((file) => {
      const fileSizeInMB = file.blobFile.size / bytesInMB;

      if (fileSizeInMB > 2) {
        toast.error(`File "${file.name}" exceeds the 2 MB limit.`);
      } else {
        validFiles.push(file);
      }
    });

    setFilesUploadDocument(validFiles); // Only allow valid files to show
  };

  const handleUpload = (file) => {
    const bytesInMB = 1048576;
    const fileSizeInBytes = file.blobFile.size;
    const fileSizeInMB = fileSizeInBytes / bytesInMB;
    if (fileSizeInMB > 2) {
      toast.error("File size exceeds the maximum limit of 2 MB.");
      return;
    }
    setUploading(true);
    previewFile(file.blobFile, (value) => {
      setFileIdProf(value);
      setUploading(false);
    });
  };
  const removeImage = () => {
    setFileIdProf(null); // Clears the previewed image
    setUploading(false); // Resets uploading state
  };
  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };
  //Form Validation
  const handlepersonalinfo = () => {
    let newErrors = {};
    if (!formData.personalInfo.email) {
      newErrors.email = "Please Enter Email";
    } else if (!ValidEmail(formData.personalInfo.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    // if (!formData.personalInfo.role) {
    //   newErrors.role = "Please Enter Your Position";
    // }

    // Validate role (position)
    if (!formData.personalInfo.role) {
      newErrors.role = "Please enter your position.";
    } else if (formData.personalInfo.role.trim().length < 2) {
      newErrors.role = "Position must be at least 2 characters.";
    }

    // Validate name
    const trimmedName = formData.personalInfo.name?.trim() || "";

    if (!trimmedName) {
      newErrors.name = "Please enter your Full Name.";
    } else if (!/^[a-zA-Z\s]*$/.test(trimmedName)) {
      newErrors.name = "Name cannot contain special characters.";
    } else if (trimmedName.length < 2) {
      newErrors.name = "Name must be at least 2 characters.";
    } else if (trimmedName.length > 40) {
      newErrors.name = "Full name cannot be longer than 40 characters.";
    }

    // if (!formData.personalInfo.lastName) {
    //   newErrors.lastName = "Please Enter Last Name.";
    // } else if (!/^[a-zA-Z\s]*$/.test(formData.personalInfo.lastName)) {
    //   newErrors.lastName = "Last Name cannot contain special characters.";
    // } else if (formData.personalInfo.lastName.length > 20) {
    //   newErrors.lastName = "Last Name cannot be longer than 20 characters.";
    // }

    // if (!formData.personalInfo.phnono) {
    //   newErrors.phnono = "Please Enter Phone Number.";
    // } else if (!/^\+?\d{8,15}$/.test(formData.personalInfo.phnono)) {
    //   newErrors.phnono =
    //     "Contact Number must be between 8 and 15 digits and contain only numbers.";
    // }
    const { length, lowercase, uppercase, number, specialChar } =
      requirementsStatus;
    const isPasswordValid =
      length && lowercase && uppercase && number && specialChar;
    if (!isPasswordValid) {
      newErrors.password = "Password does not meet all requirements.";
    }
    if (!formData.personalInfo.confirmPassword) {
      newErrors.confirmPassword = "Please Enter Confirm Password.";
    } else if (
      formData.personalInfo.confirmPassword !== formData.personalInfo.password
    ) {
      newErrors.confirmPassword = "Password and confirm password do not match.";
    }
    setPersonalInfoErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      return false;
    } else {
      return true;
    }
  };

  function ValidEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  const zipCodeRegex = /^[A-Za-z0-9\s\-]{3,10}$/;

  const handlecompanyinfo = () => {
    const bytesInMB = 1048576; // 1 MB in bytes

    let newErrors = {};

    if (!formData.companyInfo.companyName) {
      newErrors.companyName = "Please Enter Company Name.";
    } else if (
      formData.companyInfo.companyName.length < 10 ||
      formData.companyInfo.companyName.length > 50
    ) {
      newErrors.companyName =
        "Company Name must be between 10 to 50 characters.";
    }

    if (!formData.companyInfo.zipcode) {
      newErrors.zipcode = "Please Enter Postal code.";
    } else if (!zipCodeRegex.test(formData.companyInfo.zipcode)) {
      newErrors.zipcode = "Invalid Postal code format.";
    }
    if (!formData.companyInfo.country) {
      newErrors.country = "Please Select Country.";
    }

    if (!formData.companyInfo.city) {
      newErrors.city = "Please Select City.";
    }
    if (!formData.companyInfo.address) {
      newErrors.address = "Please Enter Street no";
    }
    // } else if (
    //   formData.companyInfo.address.length < 10 ||
    //   formData.companyInfo.address.length > 50
    // ) {
    //   newErrors.address = "Address must be between 10 and 50 characters.";
    // }

    if (!formData.companyInfo.contactNo) {
      newErrors.contactNo = "Please Enter Contact Number.";
    } else if (!/^\+?\d{8,14}$/.test(formData.companyInfo.contactNo)) {
      newErrors.contactNo = "Contact Number must be between 8 and 15 digits.";
    }

    // if (!formData.companyInfo.website) {
    //   newErrors.website = "Please enter website URL.";
    // } else if (
    //   formData.companyInfo.website.length < 10 ||
    //   formData.companyInfo.website.length > 50
    // ) {
    //   newErrors.website = "Website URL must be between 10 and 50 characters.";
    // } else if (!/^https?:\/\/.+/.test(formData.companyInfo.website)) {
    //   newErrors.website =
    //     "Website URL must start with 'http://' or 'https://'.";
    // } else if (!isValidURL(formData.companyInfo.website)) {
    //   newErrors.website = "Please enter a valid website URL.";
    // }

    // if (!fileIdProf) {
    //   newErrors.fileIdProf = "Please Upload Id Proof.";
    // }

    // if (filesUploadDocument.length === 0) {
    //   newErrors.filesUploadDocument = "Please Upload Business Document.";
    //   return
    // }

    if (filesUploadDocument.length > bytesInMB) {
      newErrors.filesUploadDocument = "File size exceed";
      return;
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      return false;
    } else {
      return true;
    }
  };
  function isValidURL(url) {
    const pattern =
      /^(https?:\/\/)?([\w\d-]+\.)+[\w-]{2,}(\/[\w\d-_.~:?#[\]@!$&'()*+,;=]*)*\/?$/;
    return pattern.test(url);
  }
  const handleSubmit = async () => {
    let newErrors = {};
    if (otp === "") {
      newErrors.empty = "Please enter otp.";
      setErrors(newErrors);
      return;
    }
    if (otp.length < 4) {
      newErrors.wrong = "Please enter full otp.";
      setErrors(newErrors);
      return;
    }
    setIsLoading(true);
    var verification = await VerifyOtp();
    if (!verification) {
      setIsLoading(false);
      return;
    }
    const submitData = new FormData();
    // Append the data from the original object to the FormData
    submitData.append("token", token);
    submitData.append("email", formData.personalInfo.email);
    submitData.append("password", formData.personalInfo.password);
    submitData.append("title", ""); // Title is empty in the original data
    submitData.append("first_name", formData.personalInfo.name);
    submitData.append("position", formData.personalInfo.role);
    // submitData.append("last_name", formData.personalInfo.lastName);
    submitData.append("company_name", formData.companyInfo.companyName);
    submitData.append("company_address", formData.companyInfo.address);
    submitData.append("company_Website", formData.companyInfo.website);
    submitData.append("company_Phone_no", formData.companyInfo.contactNo);
    submitData.append("country", formData.companyInfo.country); // Country is empty in the original data
    submitData.append("city", formData.companyInfo.city); // City is empty in the original data
    submitData.append("phone_no", formData.companyInfo.contactNo);
    submitData.append("zip_code", formData.companyInfo.zipcode); // Zip code is empty in the original data
    submitData.append("otp_code", otp); // OTP code is empty in the original data
    submitData.append("personal_Details", "");
    submitData.append("comapany_Details", "Active");
    submitData.append("billing_Details", "");
    submitData.append("id_Card", fileIdProf);
    filesUploadDocument.forEach((item, index) => {
      submitData.append(
        `business_Document[${index}]`,
        item.blobFile,
        item.name
      );
    });

    // submitData.append("account_Name", formData.billingInfo.accountName);
    // submitData.append("account_Number", formData.billingInfo.accountNumber);
    // submitData.append("IBAN_Number", formData.billingInfo.IBAN);
    // submitData.append("account_Credit", formData.billingInfo.accountCredit);
    // paymentDocument.forEach((item, index) => {
    //   submitData.append(`account_Document[${index}]`, item.blobFile, item.name);
    // });

    try {
      const response = await axios.post(
        baseurl + "/api/register/customer/submit",
        submitData,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setIsLoading(false);
      if (response.data.status === "success") {
        navigate("/submit");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error:", error);
    }
  };

  const VerifyOtp = async () => {
    const data = {
      token: token,
      email: formData.personalInfo.email,
      otp: otp,
    };

    try {
      const response = await axios.post(
        baseurl + "/api/register_Verify_Otp",
        data
      );
      if (response.data.status === "success") {
        return true;
      } else {
        toast.error(response.data.message);
        setErrors("");
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };
  const SendOtp = async () => {
    if (handlepersonalinfo()) {
      return;
    }
    setOtp("");
    setErrors("");
    setIsLoading(true);
    const data = {
      token: token,
      email: formData.personalInfo.email,
      name: formData.personalInfo.name,
      first_name: formData.personalInfo.name,
      last_name: formData.personalInfo.email,
      // first_name: formData.personalInfo.firstName,
      // last_name: formData.personalInfo.lastName,
    };

    try {
      const response = await axios.post(
        baseurl + "/api/register_Verify_Mail",
        data
      );
      setIsLoading(false);

      if (response.data.status === "success") {
        toast.success(
          "We've sent a OTP to your email. Please check your inbox and enter the OTP to proceed."
        );
        setActiveStep(activeStep + 1);
        setTimer(60);
        setIsExpired(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const resendOtp = async () => {
    setIsLoading(true);
    const data = {
      token: token,
      email: formData.personalInfo.email,
      first_name: formData.personalInfo.firstName,
      last_name: formData.personalInfo.lastName,
    };
    try {
      const response = await axios.post(
        baseurl + "/api/register_Verify_Mail",
        data
      );

      if (response.data.status === "success") {
        setIsLoading(false);
        toast.success("OTP has been sent.");
        setOtp(""); // Clear OTP input
        setTimer(60); // Reset to 60 seconds (or your desired time)
        setIsExpired(false);
      } else {
        toast.error(response.data.message || "Failed to resend OTP.");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong while resending OTP.");
    }
  };
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  // Previous step function
  const handlePrevious = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    }
  };
  const handleChangeotp = (otpValue) => {
    setOtp(otpValue);
    if (otpValue.trim() !== "") {
      setErrors("");
    }
  };
  const handleCreateCity = (value) => {
    const newCity = {
      label: value,
      value: value.toLowerCase().replace(/\s+/g, "-"),
    };
    setCityList((prev) => [...prev, newCity]); // Add new city to options
  };
  return (
    <>
      {isLoading && <Loader />}
      {/* <ToastContainer /> */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 5000,
        }}
      />
      {/* <div className="login">
        <div className="container ">
          <div className="text-center align-content-center">
            <NavLink to="/login">
              <img src={logo} className="login-logo mt-3" alt="logo" />
            </NavLink>
          </div>
          <div className="w-100 mt-4">
            <div className="register-form">
              <div className="register-steps-list">
                {activeStep === 1 && (
                  <div className="register-step-item ">
                    <div
                      className={`register-step-icon ${
                        activeStep === 1 ? "active-step" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faBank} />
                    </div>
                    <div className="register-step-text">
                      <div className="step-heading">Company Details</div>
                      <div className="step-value">Enter Information</div>
                    </div>
                  </div>
                )}
                {activeStep === 2 && (
                  <div className="register-step-item ">
                    <div
                      className={`register-step-icon ${
                        activeStep === 2 ? "active-step" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <div className="register-step-text">
                      <div className="step-heading">Personal Information</div>
                      <div className="step-value">Enter Information</div>
                    </div>
                  </div>
                )}
                {activeStep === 3 && (
                  <div className="register-step-item ">
                    <div
                      className={`register-step-icon ${
                        activeStep === 3 ? "active-step" : ""
                      }`}
                    >
                      <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                    <div className="register-step-text">
                      <div className="step-heading">Verify OTP</div>
                      <div className="step-value">Enter OTP</div>
                    </div>
                  </div>
                )}
              </div>
              {activeStep === 1 && (
                <div className="company-info-form">
                  <h4 className="mt-3">Company Information</h4>
              
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Company Name</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          name="companyName"
                          autoComplete="off"
                          value={formData.companyInfo.companyName}
                          onChange={(e) => handleChange(e, "companyInfo")}
                          placeholder="Enter Company Name"
                        />
                        {errors.companyName && (
                          <span className="text-danger">
                            {errors.companyName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className=" form-group mt-3">
                        <label>Select Country</label>
                        <div className="mt-2">
                          <Select
                            options={countryList}
                            isSearchable={true}
                            isClearable={isClearable}
                            className=""
                            onChange={handleselectCountry}
                            value={formData.companyInfo.countryObj}
                            getOptionLabel={(option) => (
                              <div>
                                <img
                                  src={option.flag}
                                  alt={option.label}
                                  style={{ width: "20px", marginRight: "8px" }}
                                />
                                {option.label}
                              </div>
                            )}
                            getOptionValue={(option) => option.value}
                          />
                          {errors.country && (
                            <span className="text-danger">
                              {errors.country}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className=" form-group mt-3">
                        <label>Select City</label>
                        <div className="mt-2">
                          <InputPicker
                            data={cityList}
                            labelKey="label"
                            valueKey="value"
                            creatable
                            onCreate={handleCreateCity}
                            value={formData.companyInfo.city}
                            onChange={handleselectCity}
                            searchable={true}
                            virtualized
                            searchBy={(keyword, label) =>
                              label
                                .toLowerCase()
                                .includes(keyword.toLowerCase())
                            } 
                            placeholder="Select a city..."
                          
                            style={{ width: "100%" }}
                          />
                          {errors.city && (
                            <span className="text-danger">{errors.city}</span>
                          )}
                          <br />
                          <small>
                            If desired city is not available then please enter
                            and create your city name.
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Contact No</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          autoComplete="off"
                          name="contactNo"
                          value={formData.companyInfo.contactNo}
                          onChange={(e) => handleChange(e, "companyInfo")}
                          placeholder="+123 456 7899"
                        />
                        {errors.contactNo && (
                          <span className="text-danger">
                            {errors.contactNo}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group mt-3">
                        <label>Street</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          autoComplete="off"
                          name="address"
                          value={formData.companyInfo.address}
                          onChange={(e) => handleChange(e, "companyInfo")}
                          placeholder="123 Main St"
                        />
                        {errors.address && (
                          <span className="text-danger">{errors.address}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Postal Code</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          name="zipcode"
                          autoComplete="off"
                          value={formData.companyInfo.zipcode}
                          onChange={(e) => handleChange(e, "companyInfo")}
                          placeholder="Enter Postal Code"
                        />
                        {errors.zipcode && (
                          <span className="text-danger">{errors.zipcode}</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Website</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          name="website"
                          value={formData.companyInfo.website}
                          onChange={(e) => handleChange(e, "companyInfo")}
                          placeholder="www.example.com"
                        />
                      
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group d-upload mt-3">
                        <label>Upload Business Document</label>
                        <div>
                          <Uploader
                            className="mt-2"
                            fileList={filesUploadDocument}
                            listType="picture-text"
                            accept=".png, .jpg, .jpeg, .pdf"
                            autoUpload={false}
                            action="//jsonplaceholder.typicode.com/posts/"
                            onChange={handleFileChange}
                          />
                          {errors.filesUploadDocument && (
                            <span className="text-danger">
                              {errors.filesUploadDocument}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Upload Id</label>
                        <div>
                          <Uploader
                            fileList={[]}
                            onChange={(files) => {
                              setFileList(files); 
                            }}
                            listType="picture"
                            accept=".png, .jpg, .jpeg"
                            action="//jsonplaceholder.typicode.com/posts/"
                            fileListVisible={false}
                            onUpload={handleUpload}
                          >
                            <button style={{ width: 300, height: 150 }}>
                              {uploading && (
                                <Loader backdrop center size="md" />
                              )}
                              {fileIdProf ? (
                                <img
                                  src={fileIdProf}
                                  alt="Preview"
                                  width="100%"
                                  height="100%"
                                />
                              ) : (
                                <Plus style={{ fontSize: 20 }} />
                              )}
                            </button>
                          </Uploader>
                        </div>
                        
                        {fileIdProf && (
                          <div className="text-center">
                            <Button
                              appearance="link"
                              color="red"
                              onClick={removeImage}
                            >
                              Remove
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeStep === 2 && (
                <div className="Personal-info-form">
                  <h4 className="mt-3">Personal Information</h4>
                
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Full Name</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          autoComplete="off"
                          name="name"
                          value={formData.personalInfo.name}
                          onChange={(e) => handleChange(e, "personalInfo")}
                          placeholder="Enter your Name"
                        />
                        {personalInfoErrors.name && (
                          <span className="text-danger">
                            {personalInfoErrors.name}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Email</label>
                        <input
                          className="form-control mt-2"
                          type="email"
                          name="email"
                          autocomplete="off"
                          id="registeremail"
                          value={formData.personalInfo.email}
                          onChange={(e) => handleChange(e, "personalInfo")}
                          placeholder="example@gmail.com"
                        />
                        {personalInfoErrors.email && (
                          <span className="text-danger">
                            {personalInfoErrors.email}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mt-3">
                        <label>Your Position</label>
                        <input
                          className="form-control mt-2"
                          type="text"
                          name="role"
                          autoComplete="off"
                          value={formData.personalInfo.role}
                          onChange={(e) => handleChange(e, "personalInfo")}
                          placeholder="Your Position"
                        />
                        {personalInfoErrors.role && (
                          <span className="text-danger">
                            {personalInfoErrors.role}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group  mt-3">
                        <label>Password</label>
                        <div className="input-group input-group-merge ">
                          <input
                            className="form-control "
                            type={showNewPassword ? "text" : "password"}
                            name="password"
                            autocomplete="new-password"
                            value={formData.personalInfo.password}
                            onChange={(e) => handleChange(e, "personalInfo")}
                            placeholder="*********"
                          />
                          <span
                            className="input-group-text"
                            onClick={toggleNewPasswordVisibility}
                            style={{ cursor: "pointer", marginTop: "auto" }}
                          >
                            <FontAwesomeIcon
                              icon={showNewPassword ? faEyeSlash : faEye}
                            />
                          </span>
                        </div>
                        <div
                          id="requirements"
                          className="password-requirements"
                        >
                          <p
                            className={`requirement ${
                              requirementsStatus.length
                                ? "text-success"
                                : "text-danger"
                            }`}
                            id="length"
                          >
                            Min. 8 characters
                          </p>
                          <p
                            className={`requirement ${
                              requirementsStatus.lowercase
                                ? "text-success"
                                : "text-danger"
                            }`}
                            id="lowercase"
                          >
                            Include lowercase letter
                          </p>
                          <p
                            className={`requirement ${
                              requirementsStatus.uppercase
                                ? "text-success"
                                : "text-danger"
                            }`}
                            id="uppercase"
                          >
                            Include uppercase letter
                          </p>
                          <p
                            className={`requirement ${
                              requirementsStatus.number
                                ? "text-success"
                                : "text-danger"
                            }`}
                            id="number"
                          >
                            Include number
                          </p>
                          <p
                            className={`requirement ${
                              requirementsStatus.specialChar
                                ? "text-success"
                                : "text-danger"
                            }`}
                            id="characters"
                          >
                            Include a special character: #.-?!@$%^&*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mt-3">
                        <label>Confirm Password</label>
                        <div className="input-group input-group-merge ">
                          <input
                            className="form-control"
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            autocomplete="new-password"
                            value={formData.personalInfo.confirmPassword}
                            onChange={(e) => handleChange(e, "personalInfo")}
                            placeholder="*********"
                          />
                          <span
                            className="input-group-text"
                            onClick={toggleConfirmPasswordVisibility}
                            style={{ cursor: "pointer", marginTop: "auto" }}
                          >
                            <FontAwesomeIcon
                              icon={showConfirmPassword ? faEyeSlash : faEye}
                            />
                          </span>
                        </div>
                        {personalInfoErrors.confirmPassword && (
                          <span
                            className={
                              personalInfoErrors.confirmPassword ===
                              "Password and Confirm Password matched."
                                ? "text-success"
                                : "text-danger"
                            }
                          >
                            {personalInfoErrors.confirmPassword}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {activeStep === 3 && (
                <div className="company-info-form">
                  <h4 className="mt-3 text-dark">Enter OTP</h4>
                  <p className="mt-2 text-muted">
                    An OTP has been sent to your email address. Please enter the
                    OTP to verify your email.
                  </p>

                  <div className="row justify-content-center">
                    <div className="mb-3 w-50 my-4 otp-field">
                      <OtpInput
                        value={otp}
                        onChange={handleChangeotp}
                        renderInput={(props) => <input {...props} />}
                        numInputs={5}
                        renderSeparator={<span>-</span>}
                        isInputNum={true}
                        shouldAutoFocus={true}
                        inputStyle={{
                          width: "2.5rem",
                          height: "2.5rem",
                          margin: "0 0.5rem",
                          fontSize: "1.3rem",
                          borderRadius: "4px",
                          border: "1px solid #ccc",
                        }}
                      />
                    </div>

                    {errors.empty && (
                      <span className="text-danger text-center">
                        {errors.empty}
                      </span>
                    )}
                    {errors.wrong && (
                      <span className="text-danger text-center">
                        {errors.wrong}
                      </span>
                    )}

                    <div className="text-center text-dark mt-3">
                      {isExpired ? (
                        <span className="text-danger">
                         
                          <span
                            onClick={!isExpired ? undefined : resendOtp}
                            className={`text-primary cursor-pointer ${
                              !isExpired ? "disabled" : ""
                            }`}
                            style={{
                              cursor: isExpired ? "pointer" : "not-allowed",
                            }}
                          >
                            Resend OTP?
                          </span>
                        </span>
                      ) : (
                        <>
                          Resend OTP: <strong>{timer} sec</strong>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-between mt-4 align-items-center">
                <div>
                  {activeStep > 1 && (
                    <button
                      className="btn btn-secondary text-dark"
                      onClick={handlePrevious}
                    >
                      <FontAwesomeIcon icon={faArrowLeft} /> Previous
                    </button>
                  )}
                </div>
                {activeStep < 2 && (
                  <button
                    className="theme-btn-1 ps-4 pe-4 py-2"
                    onClick={handleNext}
                  >
                    Next{" "}
                    <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
                  </button>
                )}
                {activeStep === 2 && (
                  <button
                    type="submit"
                    onClick={SendOtp}
                    className="theme-btn-1 ps-4 pe-4 py-2"
                  >
                    Send OTP
                  </button>
                )}
                {activeStep === 3 && (
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="theme-btn-1 ps-4 pe-4 py-2"
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12 text-center">
                <p className="text-muted fw-bold">
                  Back to{" "}
                  <a className=" ms-1">
                    <NavLink to="/login">
                      <b>Log In</b>
                    </NavLink>
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="row d-flex justify-content-center">
            <div className="col-6 login-footer mb-4 ">
              <p className="text-center">
                © {moment().format("YYYY")} Haramayn Rooms All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div> */}

      <div className="register d-flex align-items-center">
        <div className="overlay"></div>

        <div className="container z-2">
          <div className="row">
    
            <div className="col-xl-4 col-md-12 text-black d-flex flex-column justify-content-center text-center text-xl-start wow animate__animated animate__slideInLeft">
              <div className="">
                <img src={logo} alt="Haramayn Rooms" className="login-logo" />
              </div>
              <h1 className="fw-bold mb-3">Welcome to Haramayn Rooms</h1>
              <p className="fw-normal">
                Your comfort, our priority. Please register below to continue.
              </p>

              <div className="mt-2 d-flex gap-3 mt-3 justify-content-lg-start justify-content-center">
                   <a
                                   href="https://wa.me/966509786777" // Correct format: no +, no spaces
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="text-primary fs-4"
                                 >
                                   <FontAwesomeIcon className="text-danger" icon={faWhatsapp} />
                                 </a>
                 
                                 <a
                                   href="https://www.facebook.com/haramaynroom/"
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="text-primary fs-4"
                                 >
                                   <FontAwesomeIcon className="text-danger" icon={faFacebook} />
                                 </a>
                                 <a
                                   href="https://www.instagram.com/haramaynrooms/"
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="text-primary fs-4"
                                 >
                                   <FontAwesomeIcon className="text-danger" icon={faInstagram} />
                                 </a>
                                 <a
                                   href="https://x.com/HaramaynRooms1"
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   className="text-primary fs-4 d-flex"
                                 >
                                   <img src={twitter} style={{height:'25px', marginTop:'6px'}}  alt="Twitter" className="img-fluid text-danger" />
                                 </a>
                </div>
            </div>

           
            <div className="col-xl-8 col-md-12 col-12 wow animate__animated animate__slideInRight">
              <div
                className="card shadow-lg p-4 rounded-4 mx-auto"
                style={{ maxWidth: "100%" }}
              >
                <div className="register-steps-list">
                  {activeStep === 1 && (
                    <div className="register-step-item ">
                      <div
                        className={`register-step-icon ${
                          activeStep === 1 ? "active-step" : ""
                        }`}
                      >
                        <FontAwesomeIcon icon={faBank} />
                      </div>
                      <div className="register-step-text">
                        <div className="step-heading fw-bold text-black">Company Details</div>
                        <div className="step-value fw-bold text-secondary">Enter Information</div>
                      </div>
                    </div>
                  )}
                  {activeStep === 2 && (
                    <div className="register-step-item ">
                      <div
                        className={`register-step-icon ${
                          activeStep === 2 ? "active-step" : ""
                        }`}
                      >
                        <FontAwesomeIcon icon={faUsers} />
                      </div>
                      <div className="register-step-text">
                        <div className="step-heading fw-bold text-black">Personal Information</div>
                        <div className="step-value fw-bold text-secondary">Enter Information</div>
                      </div>
                    </div>
                  )}
                  {activeStep === 3 && (
                    <div className="register-step-item ">
                      <div
                        className={`register-step-icon ${
                          activeStep === 3 ? "active-step" : ""
                        }`}
                      >
                        <FontAwesomeIcon icon={faEnvelope} />
                      </div>
                      <div className="register-step-text">
                        <div className="step-heading fw-bold text-black">Verify OTP</div>
                        <div className="step-value fw-bold text-secondary">Enter OTP</div>
                      </div>
                    </div>
                  )}
                </div>
                {activeStep === 1 && (
                  <div className="company-info-form">
                    <h4 className="mt-3 fw-normal step-heading" style={{fontFamily:'Public Sans'}}>Company Information</h4>
                    {/* <p className="mt-2">Enter Details</p> */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Company Name</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            name="companyName"
                            autoComplete="off"
                            value={formData.companyInfo.companyName}
                            onChange={(e) => handleChange(e, "companyInfo")}
                            placeholder="Enter Company Name"
                          />
                          {errors.companyName && (
                            <span className="text-danger">
                              {errors.companyName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className=" form-group mt-3">
                          <label>Select Country</label>
                          <div className="mt-2">
                            <Select
                              options={countryList}
                              isSearchable={true}
                              isClearable={isClearable}
                              className=""
                              onChange={handleselectCountry}
                              value={formData.companyInfo.countryObj}
                              getOptionLabel={(option) => (
                                <div>
                                  <img
                                    src={option.flag}
                                    alt={option.label}
                                    style={{
                                      width: "20px",
                                      marginRight: "8px",
                                    }}
                                  />
                                  {option.label}
                                </div>
                              )}
                              getOptionValue={(option) => option.value}
                            />
                            {errors.country && (
                              <span className="text-danger">
                                {errors.country}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className=" form-group mt-3">
                          <label>Select City</label>
                          <div className="mt-2">
                            <InputPicker
                              data={cityList}
                              labelKey="label"
                              valueKey="value"
                              creatable
                              onCreate={handleCreateCity}
                              value={formData.companyInfo.city}
                              onChange={handleselectCity}
                              searchable={true}
                              virtualized
                              searchBy={(keyword, label) =>
                                label
                                  .toLowerCase()
                                  .includes(keyword.toLowerCase())
                              } // Custom search function for efficiency
                              placeholder="Select a city..."
                              // menuMaxHeight={320} // Set max height to avoid displaying too many items
                              style={{ width: "100%" }}
                            />
                            {errors.city && (
                              <span className="text-danger">{errors.city}</span>
                            )}
                            <br />
                            <small>
                              If desired city is not available then please enter
                              and create your city name.
                            </small>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Contact No</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            autoComplete="off"
                            name="contactNo"
                            value={formData.companyInfo.contactNo}
                            onChange={(e) => handleChange(e, "companyInfo")}
                            placeholder="+123 456 7899"
                          />
                          {errors.contactNo && (
                            <span className="text-danger">
                              {errors.contactNo}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="form-group mt-3">
                          <label>Street</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            autoComplete="off"
                            name="address"
                            value={formData.companyInfo.address}
                            onChange={(e) => handleChange(e, "companyInfo")}
                            placeholder="123 Main St"
                          />
                          {errors.address && (
                            <span className="text-danger">
                              {errors.address}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Postal Code</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            name="zipcode"
                            autoComplete="off"
                            value={formData.companyInfo.zipcode}
                            onChange={(e) => handleChange(e, "companyInfo")}
                            placeholder="Enter Postal Code"
                          />
                          {errors.zipcode && (
                            <span className="text-danger">
                              {errors.zipcode}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Website</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            name="website"
                            value={formData.companyInfo.website}
                            onChange={(e) => handleChange(e, "companyInfo")}
                            placeholder="www.example.com"
                          />
                          {/* {errors.website && (
                          <span className="text-danger">{errors.website}</span>
                        )} */}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group d-upload mt-3">
                          <label>Upload Business Document</label>
                          <div>
                            <Uploader
                              className="mt-2"
                              fileList={filesUploadDocument} // controlled mode!
                              listType="picture-text"
                              accept=".png, .jpg, .jpeg, .pdf"
                              autoUpload={false}
                              action="//jsonplaceholder.typicode.com/posts/"
                              onChange={handleFileChange}
                            />
                            {errors.filesUploadDocument && (
                              <span className="text-danger">
                                {errors.filesUploadDocument}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Upload Id</label>
                          <div>
                            <Uploader
                              fileList={[]}
                              onChange={(files) => {
                                setFileList(files); // Update the file list with the new file
                              }}
                              listType="picture"
                              accept=".png, .jpg, .jpeg"
                              action="//jsonplaceholder.typicode.com/posts/"
                              fileListVisible={false}
                              onUpload={handleUpload}
                            >
                              <button style={{ width: 300, height: 150 }}>
                                {uploading && (
                                  <Loader backdrop center size="md" />
                                )}
                                {fileIdProf ? (
                                  <img
                                    src={fileIdProf}
                                    alt="Preview"
                                    width="100%"
                                    height="100%"
                                  />
                                ) : (
                                  <Plus style={{ fontSize: 20 }} />
                                )}
                              </button>
                            </Uploader>
                          </div>
                          {/* {errors.fileIdProf && <span className="text-danger">{errors.fileIdProf}</span>} */}
                          {fileIdProf && (
                            <div className="text-center">
                              <Button
                                appearance="link"
                                color="red"
                                onClick={removeImage}
                              >
                                Remove
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeStep === 2 && (
                  <div className="Personal-info-form">
                    <h4 className="mt-3 fw-normal " style={{fontFamily:'Public Sans'}}>Personal Information</h4>
                    {/* <p className="mt-2">Enter Your Details</p> */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Full Name</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            autoComplete="off"
                            name="name"
                            value={formData.personalInfo.name}
                            onChange={(e) => handleChange(e, "personalInfo")}
                            placeholder="Enter your Name"
                          />
                          {personalInfoErrors.name && (
                            <span className="text-danger">
                              {personalInfoErrors.name}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Email</label>
                          <input
                            className="form-control mt-2"
                            type="email"
                            name="email"
                            autocomplete="off"
                            id="registeremail"
                            value={formData.personalInfo.email}
                            onChange={(e) => handleChange(e, "personalInfo")}
                            placeholder="example@gmail.com"
                          />
                          {personalInfoErrors.email && (
                            <span className="text-danger">
                              {personalInfoErrors.email}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group mt-3">
                          <label>Your Position</label>
                          <input
                            className="form-control mt-2"
                            type="text"
                            name="role"
                            autoComplete="off"
                            value={formData.personalInfo.role}
                            onChange={(e) => handleChange(e, "personalInfo")}
                            placeholder="Your Position"
                          />
                          {personalInfoErrors.role && (
                            <span className="text-danger">
                              {personalInfoErrors.role}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group  mt-3">
                          <label>Password</label>
                          <div className="input-group input-group-merge ">
                            <input
                              className="form-control "
                              type={showNewPassword ? "text" : "password"}
                              name="password"
                              autocomplete="new-password"
                              value={formData.personalInfo.password}
                              onChange={(e) => handleChange(e, "personalInfo")}
                              placeholder="*********"
                            />
                            <span
                              className="input-group-text"
                              onClick={toggleNewPasswordVisibility}
                              style={{ cursor: "pointer", marginTop: "auto" }}
                            >
                              <FontAwesomeIcon
                                icon={showNewPassword ? faEyeSlash : faEye}
                              />
                            </span>
                          </div>
                          <div
                            id="requirements"
                            className="password-requirements"
                          >
                            <p
                              className={`requirement ${
                                requirementsStatus.length
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                              id="length"
                            >
                              Min. 8 characters
                            </p>
                            <p
                              className={`requirement ${
                                requirementsStatus.lowercase
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                              id="lowercase"
                            >
                              Include lowercase letter
                            </p>
                            <p
                              className={`requirement ${
                                requirementsStatus.uppercase
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                              id="uppercase"
                            >
                              Include uppercase letter
                            </p>
                            <p
                              className={`requirement ${
                                requirementsStatus.number
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                              id="number"
                            >
                              Include number
                            </p>
                            <p
                              className={`requirement ${
                                requirementsStatus.specialChar
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                              id="characters"
                            >
                              Include a special character: #.-?!@$%^&*
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mt-3">
                          <label>Confirm Password</label>
                          <div className="input-group input-group-merge ">
                            <input
                              className="form-control"
                              type={showConfirmPassword ? "text" : "password"}
                              name="confirmPassword"
                              autocomplete="new-password"
                              value={formData.personalInfo.confirmPassword}
                              onChange={(e) => handleChange(e, "personalInfo")}
                              placeholder="*********"
                            />
                            <span
                              className="input-group-text"
                              onClick={toggleConfirmPasswordVisibility}
                              style={{ cursor: "pointer", marginTop: "auto" }}
                            >
                              <FontAwesomeIcon
                                icon={showConfirmPassword ? faEyeSlash : faEye}
                              />
                            </span>
                          </div>
                          {personalInfoErrors.confirmPassword && (
                            <span
                              className={
                                personalInfoErrors.confirmPassword ===
                                "Password and Confirm Password matched."
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {personalInfoErrors.confirmPassword}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeStep === 3 && (
                  <div className="company-info-form">
                    <h4 className="mt-3 text-dark fw-normal" style={{fontFamily:'Public Sans'}}>Enter OTP</h4>
                    <p className="mt-2 text-muted">
                      An OTP has been sent to your email address. Please enter
                      the OTP to verify your email.
                    </p>

                    <div className="row justify-content-start justify-content-md-center ">
                      <div className="mb-3 w-50 my-4 otp-field">
                        <OtpInput
                          value={otp}
                          onChange={handleChangeotp}
                          renderInput={(props) => <input {...props} />}
                          numInputs={5}
                          renderSeparator={<span>-</span>}
                          isInputNum={true}
                          shouldAutoFocus={true}
                          inputStyle={{
                            width: "2.5rem",
                            height: "2.5rem",
                            margin: "0 0.5rem",
                            fontSize: "1.3rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>

                      {errors.empty && (
                        <span className="text-danger text-center">
                          {errors.empty}
                        </span>
                      )}
                      {errors.wrong && (
                        <span className="text-danger text-center">
                          {errors.wrong}
                        </span>
                      )}

                      <div className="text-center text-dark mt-3">
                        {isExpired ? (
                          <span className="text-danger">
                            {/* OTP expired.{" "} */}
                            <span
                              onClick={!isExpired ? undefined : resendOtp}
                              className={`text-primary cursor-pointer ${
                                !isExpired ? "disabled" : ""
                              }`}
                              style={{
                                cursor: isExpired ? "pointer" : "not-allowed",
                              }}
                            >
                              Resend OTP?
                            </span>
                          </span>
                        ) : (
                          <>
                            Resend OTP: <strong>{timer} sec</strong>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-between mt-4 align-items-center">
                  <div>
                    {activeStep > 1 && (
                      <button
                        className="btn btn-secondary text-dark"
                        onClick={handlePrevious}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} /> Previous
                      </button>
                    )}
                  </div>
                  {activeStep < 2 && (
                    <button
                      className="theme-btn-1 ps-4 pe-4 py-2"
                      onClick={handleNext}
                    >
                      Next{" "}
                      <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
                    </button>
                  )}
                  {activeStep === 2 && (
                    <button
                      type="submit"
                      onClick={SendOtp}
                      className="theme-btn-1 ps-4 pe-4 py-2"
                    >
                      Send OTP
                    </button>
                  )}
                  {activeStep === 3 && (
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="theme-btn-1 ps-4 pe-4 py-2"
                    >
                      Submit
                    </button>
                  )}
                </div>

                <div className="text-center mt-3">
                  <p className="text-muted fw-bold">
                    Back to{" "}
                    <a className=" ms-1">
                      <NavLink to="/login">
                        <b>Log In</b>
                      </NavLink>
                    </a>
                  </p>
                  <p className="text-center">
                    © {moment().format("YYYY")} Haramayn Rooms All Rights
                    Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Register;
